(() => {
  if (window.rdGiftController) return;
  const configNode = document.getElementById('rd-gift-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const variants = Array.isArray(config.variants) ? config.variants : [];
  let selectedId = String(config.selectedVariant);
  let cartState;
  let running;
  let timer;
  let rerun = false;
  let giftError = false;
  const rate = () => Number(window.Shopify?.currency?.rate) || 1;
  const qualifies = price => Number(price) > config.thresholdGBP * rate() + 0.01;
  const giftItems = cart => cart.items.filter(item => String(item.variant_id) === String(config.giftVariant));
  const eligibleItems = cart => cart.items.filter(item => String(item.variant_id) !== String(config.giftVariant) && qualifies(item.original_price) && item.quantity > 0);
  const meta = () => document.querySelector('.product-section .product-single__meta');
  function card() {
    const parent = meta();
    if (!parent) return null;
    let offer = parent.querySelector('.rd-gift-card');
    if (!offer) {
      const template = document.getElementById('rd-gift-card-template');
      if (!template) return null;
      offer = template.content.firstElementChild.cloneNode(true);
    }
    const policy = parent.querySelector('.rd-signature-policy,.rd-pillow-policy');
    const shell = parent.querySelector('.rd-default-purchase-shell');
    const button = parent.querySelector('[data-add-to-cart]');
    if (policy) {
      if (policy.nextElementSibling !== offer) policy.after(offer);
    } else if (shell) {
      if (offer.parentElement !== shell) shell.append(offer);
    } else if (button) {
      const anchor = button.closest('.product-block') || button;
      if (anchor.nextElementSibling !== offer) anchor.after(offer);
    }
    return offer;
  }
  function render(error = giftError) {
    giftError = error;
    const offer = card();
    if (!offer) return;
    const formVariant = meta()?.querySelector('form[action*="/cart/add"] [name="id"]');
    if (formVariant?.value) selectedId = String(formVariant.value);
    const variant = variants.find(item => String(item.id) === selectedId);
    offer.hidden = !config.giftAvailable || !variant || !qualifies(variant.price);
    const unlocked = cartState && eligibleItems(cartState).length > 0 && giftItems(cartState).length > 0;
    const title = offer.querySelector('[data-rd-gift-title]');
    const titleText = unlocked ? config.unlockedText : config.lockedText;
    if (title.textContent !== titleText) title.textContent = titleText;
    offer.querySelector('[data-rd-gift-progress]').style.width = unlocked ? '100%' : '75%';
    const message = offer.querySelector('[data-rd-gift-error]');
    message.hidden = !error;
    const errorText = error ? config.errorText : '';
    if (message.textContent !== errorText) message.textContent = errorText;
  }
  async function request(path, body) {
    const response = await fetch(root + path, body ? {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)} : {headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) throw new Error('Gift cart request failed');
    return response.json();
  }
  async function reconcile() {
    let cart = await request('cart.js');
    const gifts = giftItems(cart);
    const eligible = config.giftAvailable && eligibleItems(cart).length > 0;
    let changed = false;
    if (eligible && gifts.length === 0) {
      await request('cart/add.js', {items:[{id:config.giftVariant,quantity:1}]});
      changed = true;
    } else if (!eligible && gifts.length) {
      for (const gift of gifts) await request('cart/change.js', {id:gift.key,quantity:0});
      changed = true;
    } else if (eligible && (gifts.length > 1 || gifts[0]?.quantity !== 1)) {
      for (let i=0;i<gifts.length;i++) await request('cart/change.js', {id:gifts[i].key,quantity:i===0?1:0});
      changed = true;
    }
    cartState = changed ? await request('cart.js') : cart;
    render(false);
    if (changed) {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('rd:gift-updated', {detail:{cart:cartState}}));
      if (window.location.pathname.replace(/\/$/, '') === (root + 'cart').replace(/\/$/, '')) window.location.reload();
    }
    return cartState;
  }
  function sync() {
    if (running) { rerun = true; return running; }
    running = reconcile().catch(error => { render(true); throw error; }).finally(() => {
      running = null;
      if (rerun) { rerun = false; schedule(); }
    });
    return running;
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(() => sync().catch(() => {}), 180);
  }
  window.rdGiftController = {sync};
  document.addEventListener('variant:change', event => {
    if (event.detail?.variant?.id) selectedId = String(event.detail.variant.id);
    setTimeout(() => render(), 0);
  });
  document.addEventListener('change', event => {
    if (event.target.closest('.product-section')) setTimeout(() => render(), 50);
  });
  ['ajaxProduct:added','cart:updated','cart:build','cart:refresh','shopify:section:load'].forEach(name => document.addEventListener(name, schedule));
  document.addEventListener('click', event => {
    if (event.target.closest('.js-qty__adjust,.cart__remove,a[href*="/cart/change"],[name="checkout"],.cart__checkout')) schedule();
  });
  document.addEventListener('submit', async event => {
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout' || submitter.dataset.rdGiftReady) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    submitter.disabled = true;
    try {
      await sync();
      submitter.disabled = false;
      submitter.dataset.rdGiftReady = 'true';
      event.target.requestSubmit(submitter);
    } catch (error) {
      submitter.disabled = false;
      delete submitter.dataset.rdGiftReady;
    }
  }, true);
  new MutationObserver(() => render()).observe(document.querySelector('main') || document.body, {childList:true,subtree:true});
  render();
  schedule();
})();
